import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

export type OilNormData = {
    vin: string;
    unit: string;
    fix: {
        amount: number;
        oilNorm: [string, string];
    };
    flexible: {
        amount: number;
        oilNorm: [string, string];
    };
    transactionId: string;
    dealerId: string | null;
};

export class OilNormService {

    private readonly resourceHostId: string;

    constructor(private readonly authService: IAuthServiceV2, stage: string) {
        this.resourceHostId = `cwat-oil-norm-service-${stage}`;
    };

    public async getVehicleOilNorm(vin: string, language: string): Promise<OilNormData> {
        const url = `api/oil-norm/${vin}?language=${language}`;

        const response = await this.authService.get(this.resourceHostId, url);

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

        return await response.json() as OilNormData;
    }
}